import React from 'react';

import styles from './featuredResearchReorderFormStyles';

import Card from 'buyside/components/presentation/Card/card';
import RecentIdea from 'buyside/components/presentation/RecentIdea/recentIdea';
import RecentWhitePaper from 'buyside/components/presentation/RecentWhitePaper/RecentWhitePaper';
import ReorderForm from 'buyside/components/presentation/Form/ReorderForm/reorderForm';

import { defaultUserImageUrl } from 'buyside/util/urlHelper';

const renderIdea = idea => {
  return (
    <Card customStyles={styles.researchCard}>
      <RecentIdea idea={idea} showEntityName showReturnInfo={false} showExcerpt={false} />
    </Card>
  );
};

const renderWhitePaper = whitePaper => {
  const {
    elevatorPitch,
    esgs,
    geographies,
    globalMacros,
    id,
    sectors,
    submittedAt,
    title,
    user: { id: userId, displayName, profileImageUrl }
  } = whitePaper;
  if (!submittedAt) return null;
  return (
    <Card customStyles={styles.researchCard}>
      <RecentWhitePaper
        displayName={displayName}
        elevatorPitch={elevatorPitch}
        esgs={esgs}
        geographies={geographies}
        globalMacros={globalMacros}
        id={id}
        profileImageUrl={profileImageUrl || defaultUserImageUrl()}
        sectors={sectors}
        submittedAt={submittedAt}
        title={title}
        userId={userId}
      />
    </Card>
  );
};

const FeaturedResearchReorderForm = ({ modalId }) => {
  return (
    <>
      <h3 className={styles.heading}>REORDER FEATURED IDEAS:</h3>
      <ReorderForm
        className={styles.reorderForm}
        modalId={modalId}
        attr="fundProfile.featuredResearch"
        renderItem={renderIdea}
      />
      <h3 className={styles.heading}>REORDER FEATURED MACRO / THEMATIC RESEARCH</h3>
      <ReorderForm
        className={styles.reorderForm}
        modalId={modalId}
        attr="fundProfile.featuredWhitePaperResearch"
        renderItem={renderWhitePaper}
      />
    </>
  );
};

export default FeaturedResearchReorderForm;
